import React from 'react';
import ReactDOM from 'react-dom/client';
import Body from './App';
import "./css/header.css";
import "./css/subHeader.css";
import "./css/form.css";
import "./css/about.css";
import "./css/buy.css";

ReactDOM.createRoot(document.getElementById("root")).render(<Body />);
